import { render, staticRenderFns } from "./DataRating.vue?vue&type=template&id=62c19604&scoped=true"
import script from "./DataRating.vue?vue&type=script&lang=js"
export * from "./DataRating.vue?vue&type=script&lang=js"
import style0 from "./DataRating.vue?vue&type=style&index=0&id=62c19604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c19604",
  null
  
)

export default component.exports